<template>

  <section class="o-section">
    <div class="o-section__wrapper is-center-center" ref="wrapper">

      <div class="o-section__text" v-if="active">
        <div ref="textA" data-scene="12a">
          <div v-for="line in copy.top" v-html="line" :key="line"></div>
        </div>
      </div>

      <div class="o-section__figure-wrapper" v-if="active">
        <figure class="o-section__figure" ref="figureA" data-scene="12a">
          <Img :src="require('@/assets/scene12/spread12_a.png')" filename="spread12_a" />
        </figure>

        <figure class="o-section__figure anim-scene-12" ref="figureC" data-scene="12c">
          <Img :src="require('@/assets/scene12/spread12_c.png')" filename="spread12_c" />
        </figure>

        <figure class="o-section__figure" ref="figureB" data-scene="12b">
          <Img :src="require('@/assets/scene12/spread12_b.png')" filename="spread12_b" />
        </figure>
      </div>
    </div>
  </section>

</template>

<script>
import Img from '@/components/Img'

export default {
  name: 'Scene12',
  props: ['options', 'active', 'copy', 'disableBlur'],

  mounted () {
    this.$root.$on('startScene12', () => {
      this.init()
    })
  },

  methods: {
    init () {
      this.$anime({
        targets: this.$refs.figureA,
        scale: [1.1, 1],
        duration: this.options.durationLarge,
        easing: this.options.easing
      })

      setTimeout(() => {
        this.$anime({
          targets: this.$refs.figureA,
          scale: [1, 1.01],
          duration: this.options.durationRegular,
          easing: this.options.easing,
          loop: true,
          direction: 'alternate'
        })
      }, this.options.durationLarge)

      this.$anime({
        targets: this.$refs.figureB,
        scale: [0.95, 1],
        duration: this.options.durationLarge,
        easing: this.options.easing
      })

      if (this.disableBlur) {
        this.$anime({
          targets: this.$refs.figureA,
          opacity: [0, 1],
          duration: this.options.durationRegular,
          easing: this.options.easing
        })

        this.$anime({
          targets: this.$refs.figureB,
          opacity: [0, 1],
          duration: this.options.durationRegular,
          easing: this.options.easing
        })

        this.$anime({
          targets: this.$refs.figureC,
          opacity: [0, 1],
          duration: this.options.durationRegular,
          easing: this.options.easing
        })
      } else {
        this.$anime({
          targets: this.$refs.figureA,
          filter: ['blur(5px)', 'blur(0px)'],
          duration: this.options.durationRegular,
          easing: this.options.easing
        })

        this.$anime({
          targets: this.$refs.figureB,
          filter: ['blur(15px)', 'blur(0px)'],
          duration: this.options.durationRegular,
          easing: this.options.easing
        })

        this.$anime({
          targets: this.$refs.figureC,
          filter: ['blur(10px)', 'blur(0px)'],
          duration: this.options.durationRegular,
          easing: this.options.easing
        })
      }

      this.$anime({
        targets: this.$refs.figureC,
        translateY: ['-15px', '0'],
        scale: [0.9, 1],
        duration: this.options.durationLarge,
        easing: this.options.easing
      })
    }
  },

  components: {
    Img
  }
}
</script>
